import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
  token: null,
  user: {},
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action) => {
      localStorage.setItem(`token`, JSON.stringify(action.payload));
      state.token = action.payload;
    },
    setUser: (state, action) => {
      localStorage.setItem(`user`, JSON.stringify(action.payload));
      state.user = action.payload;
    },
  },
});

export const { setAuth, setUser } = authSlice.actions;

export default authSlice.reducer;
